<template>

  <!-- modal -->
  <b-modal
    id="modal-multi-1"
    size="lg"
    title="Detalhes da campanha"
    ok-only
    ok-title="Ok"
    no-stacking
  >
    <b-overlay
      id="overlay-background"
      :show="show"
      variant="light"
      opacity="0.85"
      blur="2px"
      rounded="sm"
    >
      <b-row>
        <b-col
          xl="4"
          md="4"
          sm="6"
        >
          <statistic-card-vertical
            color="primary"
            icon="UsersIcon"
            :statistic="items.length"
            statistic-title="Contatos"
          />
        </b-col>
        <b-col
          xl="4"
          md="4"
          sm="6"
        >
          <statistic-card-vertical
            color="primary"
            icon="SendIcon"
            :statistic=" (totalSend >= 1) ? (((totalSend)* 100) / (items.length)).toFixed(2) + '%' : 0 "
            statistic-title="Enviado"
          />
        </b-col>
        <b-col
          xl="4"
          md="4"
          sm="6"
        >
          <statistic-card-vertical
            color="primary"
            icon="EyeIcon"
            statistic="-"
            statistic-title="Lido"
          />
        </b-col>
      </b-row>

      <b-row>

        <b-col
          xl="12"
          md="12"
          sm="12"
        >

          <app-collapse>

            <app-collapse-item title="Mensagem">

              <b-row>
                <b-col
                  xl="2"
                  cols="2"
                />
                <b-col
                  xl="4"
                  cols="4"
                  style="background-image: url('https://user-images.githubusercontent.com/15075759/28719144-86dc0f70-73b1-11e7-911d-60d70fcded21.png');"
                >
                  <b-card
                    style="background-color: #d1fecf;  margin-top: 5%; "
                    class="text-center"
                    :img-src="imageCampaign"
                    :footer="textButton"
                  >
                    <p class="text-left">
                      {{ message }}
                    </p>
                  </b-card>
                </b-col>
                <b-col
                  xl="2"
                  cols="4"
                />
              </b-row>

              <!----<img style="max-width: 100%;"  :src="imageCampaign" />
              <b-form-textarea
                id="textarea-plaintext"
                plaintext
                :value="message"
              /> --->
            </app-collapse-item>

          </app-collapse>
        </b-col>
      </b-row>
      <br><br>
      <b-row>
        <b-col
          xl="12"
          md="12"
          sm="12"
        ><h3>Contatos:</h3>
          <Contacts :items="items" />
        </b-col>
      </b-row>
    </b-overlay>
  </b-modal>
</template>

<script>
import BCardCode from '@core/components/b-card-code'
import AppCollapse from '@core/components/app-collapse/AppCollapse.vue'
import AppCollapseItem from '@core/components/app-collapse/AppCollapseItem.vue'
import {
  BFormRadioGroup, BFormRadio, BFormGroup, BCardText, BFormInput, BInputGroupAppend,
  BInputGroupPrepend, BButton, BInputGroup, BModal, VBModal, BRow, BCol, BOverlay, BFormTextarea,
  BCard,
} from 'bootstrap-vue'
import StatisticCardVertical from '@core/components/statistics-cards/StatisticCardVertical.vue'
import Contacts from './table'

export default {
  components: {
    BCardCode,
    AppCollapse,
    AppCollapseItem,
    BFormRadioGroup,
    BFormRadio,
    BCardText,
    BFormGroup,
    BFormInput,
    BInputGroupAppend,
    BInputGroupPrepend,
    BButton,
    BInputGroup,
    BFormInput,
    BModal,
    BRow,
    BCol,
    StatisticCardVertical,
    Contacts,
    BOverlay,
    BFormTextarea,
    BCard,
  },
  directives: {
    'b-modal': VBModal,
  },
  props: {
    items: Array,
    totalSend: Number,
    show: Boolean,
    message: String,
    imageCampaign: String,
    linkButton: String,
    textButton: String,
  },
  data() {
    return {
      collapseType: 'default',
    }
  },
  methods: {

  },
}
</script>
